<template>
  <div class="article-details">
    <el-main>
      <h3 class="title">{{ articleRes.title }}</h3>
      <div class="other_info">
        <div class="time">
          發佈時間：{{ $dayjs(articleRes.publish_time).format("YYYY-MM-DD") }}
        </div>
        <!-- <div class="collect">
        <i v-if="!favouriteState" class="el-icon-star-off little_hand" @click="fncollection"></i>
        <i v-else class="el-icon-star-on little_hand" @click="fncollection"></i>
      </div> -->
      </div>

      <div v-html="articleRes.content" class="con"></div>
      <div class="share_container">
        <span class="tag">分享：</span>
        <div class="wx little_hand">
          <el-popover
            placement="top"
            width="100"
            trigger="hover"
            popper-class="wx_popper"
          >
            <el-image
              style="width: 100px; height: 100px"
              :src="qrCodeImg"
              fit="cover"
            ></el-image>
            <img
              slot="reference"
              src="https://www.sztmas.cn/assets/images/weixin1.png"
              alt=""
            />
          </el-popover>
        </div>
        <div class="wb little_hand" @click="shareToWb">
          <img src="https://www.sztmas.cn/assets/images/weibo.png" alt="" />
        </div>
      </div>
      <div class="relate_article">
        <!-- <ul>
        <li>上一篇：台湾复兴航空突然停航！到底发生了什么？</li>
        <li>下一篇：台湾复兴航空突然停航！到底发生了什么？</li>
      </ul> -->
      </div>
    </el-main>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      articleRes: {},
    };
  },
  computed: {
    ...mapState(["user_id", "validToken"]),
    qrCodeImg() {
      return (
        "https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=https://api2.ts960.com/wechatxh/html/association-file-details.html?cunpan_id=" +
        this.$route.params.id
      );
    },
  },
  watch: {
    user_id(val) {},
  },
  methods: {
    async getArticleDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/cunpanExplain/${this.$route.params.id}`
      );
      console.log(res);
      // if (res.code !== "200") return this.$message.error(res.msg);
      this.articleRes = res.data;

      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    shareToWb() {
      let title = this.articleRes.title;
      let url =
        "https://api2.ts960.com/wechatxh/html/article.html?contentid=" +
        this.$route.params.id;
      let main_image = JSON.parse(this.articleRes.main_image);
      let picurl = main_image.map((img) =>
        !/^http/.test(img) ? this.$imgUrl + img : img
      );
      console.log(picurl);
      var sharesinastring =
        "http://v.t.sina.com.cn/share/share.php?title=" +
        title +
        "&url=" +
        url +
        "&content=utf-8&sourceUrl=" +
        url +
        "&pic=" +
        picurl[0];
      window.open(
        sharesinastring,
        "newwindow",
        "height=400,width=400,top=100,left=100"
      );
    },
  },
  created() {
    this.getArticleDetails();
  },
  mounted() {},
};
</script>
<style>
/* 文章内嵌的视频高度 */
iframe {
  min-height: 506px !important;
}
.con {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #222222;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
}
.con img {
  max-width: 100% !important;
  display: block;
  margin: 20px 0;
  border-radius: 4px;
}
</style>
<style lang="less" scoped>
.article-details {
  background: #f2f2f2;
  padding: 50px 0;
}
.el-main {
  width: 1000px;
  padding: 36px 40px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 36px;
    color: #222222;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .other_info {
    position: relative;
    margin-bottom: 40px;
    .time {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #888888;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
    }
    .collect {
      position: absolute;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);
      i {
        font-size: 30px;
        margin-right: 18px;
      }
      .el-icon-star-on {
        color: #3135cb;
      }
      .el-button {
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        background: #3135cb;
        padding: 2px 14px;
        border-radius: 28px;
        border: none;
      }
    }
  }
  .fix_btn {
    position: fixed;
    top: 50%;
    right: 27px;
    z-index: 99;

    div {
      cursor: pointer;
      width: 60px;
      height: 60px;
      border-radius: 8px;
      margin-bottom: 5px;
      background-color: #fff;
      background-size: contain;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div:hover {
      background: rgba(0, 0, 0, 0.04);
    }
    em {
      width: 30px;
      height: 30px;
      display: inline-block;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      font-size: 30px;
    }
    .btn_wx em {
      background-image: url("../assets/images/weixin1.png");
    }
    .btn_xl em {
      background-image: url("../assets/images/weibo.png");
    }
    .btn_top em {
      background-image: url("../assets/imgs/arrow.svg");
      transform: rotate(-90deg);
    }
    .btn_xl img {
      width: 30px;
      height: 30px;
    }
  }
  .show_more {
    width: 100%;
    text-align: center;
    padding: 40px 0;
    // margin-top: -74px;
    position: relative;
    .artlineContent {
      // background: url(../assets/images/lineContent.png) repeat-x;
      height: 44px;
      z-index: 2;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .tongjiNumber {
      font-size: 18px;
      color: #282828;
      text-align: center;
      .triangle {
        border-bottom: 4px solid transparent;
        border-top: 4px solid #f12e2b;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        width: 0;
        height: 0;
        overflow: hidden;
        margin: 5px auto 28px;
      }
    }
    .loginContent {
      font-size: 18px;
      margin-bottom: 30px;
      .loginColor {
        color: #2686d5;
        border-bottom: 1px solid #2686d5;
        padding-bottom: 2px;
        font-size: 18px;
      }
    }
    .subBtnContent {
      margin-bottom: 25px;
      font-size: 18px;
      color: #b0977f;
      text-align: right;
      width: 350px;
      margin: 0 auto 25px;
      height: 44px;
      .subLeftContent {
        border-right: 1px solid #f8ad18;
        padding-right: 18px;
        margin-right: 18px;
        float: left;
      }
      .subRightContent {
        float: left;
        width: 150px;
        border-radius: 40px;
        line-height: 44px;
        background: #f8ad18;
        font-size: 20px;
        color: #fff;
        position: relative;
        text-align: center;
      }
    }
  }
  .show_more .show_more_btn {
    text-decoration: none;
    color: #333;
    padding: 10px 20px;
    border: 1px solid #67a2ea;
    border-radius: 40px;
    font-size: 18px;
  }
  .thumb {
    border: 1px solid #3135cb;
    border-radius: 50px;
    margin: auto;
    margin-top: 40px;
    width: 80px;
    height: 80px;
    background: #20317f;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      filter: drop-shadow(#fff 80px 0);
      transform: translateX(-80px);
      width: 30px;
      height: 30px;
      margin-bottom: 2px;
    }
    .thumb-num {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .share_container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 15px;
    .tag {
      font-size: 16px;
      font-weight: 300;
      color: #424242;
      line-height: 42px;
      margin-right: 15px;
      padding: 6px 0;
    }
    .wx {
      span {
        display: flex;
      }
    }
    div {
      width: 45px;
      height: 45px;
      border-radius: 45px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      padding: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-right: 10px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  hr {
    opacity: 0.06;
  }
  .relate_article {
    ul li {
      font-size: 16px;
      font-weight: 300;
      color: rgba(66, 66, 66, 1);
      line-height: 30px;
      cursor: pointer;
    }
  }
}
/deep/.el-dialog {
  border-radius: 22px;
  margin-top: 30vh !important;
  .el-dialog__title {
    line-height: 60px;
    font-size: 20px;
    color: #303133;
    font-weight: bold;
  }
  i {
    position: absolute;
    right: 25px;
    top: 25px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }
  .fee_list {
    display: flex;
    align-content: center;
    justify-content: space-around;
    .fee_list_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 20px;
      border-right: 1px dashed #ccc;
      cursor: pointer;
      .price {
        font-size: 18px;
        color: #f12e2b;
      }
      .name {
        font-size: 18px;
      }
      .desc {
        font-size: 16px;
        color: #ccc;
      }
      .duration {
        font-size: 16px;
      }
    }
    .fee_list_item:last-child {
      border: none;
    }
  }
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
@media screen and (max-width: 768px) {
  .article-details{
    background: #fff;
    padding: 10px 0;
  }
  .el-main {
    width: 100%;
    padding: 0 15px;
     .title {
      font-size: 20px;
    }
    .con {
      line-height: 30px;
    }
  }
}
</style>
